import React from 'react'
import Navbar from '../header/Navbar'
import Footer from '../footer/Footer'
import HeroImg2 from '../additional/HeroImg2'
import PricingCard from '../additional/PricingCard'
import Projects from '../additional/Projects'

const Project = () => {
  return (
    <div>
      <Navbar/>
      <HeroImg2 heading="PROJECTS" text="Some of my most recent works"/>
      <Projects/>
      <PricingCard/>
      <Footer/>
    </div>
  )
}

export default Project